/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return props.table
}
